/* eslint-disable */

import request from '@/utils/request'
import qs from 'qs'

export function getListFreeRoom(query) {
  return request({
    url: '/report-service/v1/report/free-room',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getListFreeRoomExcel(query) {
  return request({
    url: '/report-service/v1/report/free-room/to-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
